export default __webpack_public_path__ + "static/media/my-account-hover.19f8d32a.svg";